// eslint-disable-next-line global-require
require('utils/errorReporting').run(() => require('./app'));



// WEBPACK FOOTER //
// ./app/run.js